/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Change_Detection_Low_ButtonInputs */

const en_scene_change_detection_low_button = /** @type {(inputs: Scene_Change_Detection_Low_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Low`)
};

const fr_scene_change_detection_low_button = /** @type {(inputs: Scene_Change_Detection_Low_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faible`)
};

const de_scene_change_detection_low_button = /** @type {(inputs: Scene_Change_Detection_Low_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niedrig`)
};

const it_scene_change_detection_low_button = /** @type {(inputs: Scene_Change_Detection_Low_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basso`)
};

const ru_scene_change_detection_low_button = /** @type {(inputs: Scene_Change_Detection_Low_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Низкий`)
};

const es_scene_change_detection_low_button = /** @type {(inputs: Scene_Change_Detection_Low_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bajo`)
};

const zh_cn2_scene_change_detection_low_button = /** @type {(inputs: Scene_Change_Detection_Low_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`低的`)
};

const ja_scene_change_detection_low_button = /** @type {(inputs: Scene_Change_Detection_Low_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`低い`)
};

const hi_scene_change_detection_low_button = /** @type {(inputs: Scene_Change_Detection_Low_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कम`)
};

const pt_pt2_scene_change_detection_low_button = /** @type {(inputs: Scene_Change_Detection_Low_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baixo`)
};

/**
* | output |
* | --- |
* | "Low" |
*
* @param {Scene_Change_Detection_Low_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_change_detection_low_button = /** @type {((inputs?: Scene_Change_Detection_Low_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Change_Detection_Low_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_scene_change_detection_low_button(inputs)
	if (locale === "de") return de_scene_change_detection_low_button(inputs)
	if (locale === "it") return it_scene_change_detection_low_button(inputs)
	if (locale === "ru") return ru_scene_change_detection_low_button(inputs)
	if (locale === "es") return es_scene_change_detection_low_button(inputs)
	if (locale === "zh-CN") return zh_cn2_scene_change_detection_low_button(inputs)
	if (locale === "ja") return ja_scene_change_detection_low_button(inputs)
	if (locale === "hi") return hi_scene_change_detection_low_button(inputs)
	if (locale === "pt-PT") return pt_pt2_scene_change_detection_low_button(inputs)
	return en_scene_change_detection_low_button(inputs)
});